var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSolidEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 50,
    viewBox: "0 0 56 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1409_60)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.1417 8.125L47.9111 16.9336C48.2806 17.3047 48.2806 17.9102 47.9111 18.2812L26.6778 39.6094L17.6556 40.6152C16.45 40.7519 15.4292 39.7266 15.5653 38.5156L16.5667 29.4531L37.8 8.125C38.1694 7.75391 38.7722 7.75391 39.1417 8.125ZM54.8917 5.88867L50.1472 1.12305C48.6694 -0.361328 46.2681 -0.361328 44.7806 1.12305L41.3389 4.58008C40.9694 4.95117 40.9694 5.55664 41.3389 5.92773L50.1083 14.7363C50.4778 15.1074 51.0806 15.1074 51.45 14.7363L54.8917 11.2793C56.3694 9.78516 56.3694 7.37305 54.8917 5.88867ZM37.3333 33.8086V43.75H6.22222V12.5H28.5639C28.875 12.5 29.1667 12.373 29.3903 12.1582L33.2792 8.25195C34.0181 7.50977 33.4931 6.25 32.4528 6.25H4.66667C2.09028 6.25 0 8.34961 0 10.9375V45.3125C0 47.9004 2.09028 50 4.66667 50H38.8889C41.4653 50 43.5556 47.9004 43.5556 45.3125V29.9023C43.5556 28.8574 42.3014 28.3398 41.5625 29.0723L37.6736 32.9785C37.4597 33.2031 37.3333 33.4961 37.3333 33.8086Z",
    fill: "var(--color-button-background)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1409_60"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 50,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolidEdit);
export default __webpack_public_path__ + "static/media/solid_edit.5737b9ed.svg";
export { ForwardRef as ReactComponent };